/* ═══════════════════════════════════════════════════════════════
   Brennweite aus den EXIF-Daten eines JPEG

   Für die Abwicklung aus Fotos zählt, wie weitwinklig das Foto ist:
   Daraus folgt die Perspektive (wie stark sich Etikettränder biegen,
   wie weit man um die Flasche herumsieht). Telefone schreiben die
   Brennweite „wie bei Kleinbild“ (FocalLengthIn35mmFilm, 0xA405) in
   die Datei; damit ist die Brennweite in Pixeln
   f = f35 / 43,27 mm · Bilddiagonale in Pixeln (43,27 mm ist die
   Diagonale des Kleinbilds). Fehlt sie, rechnet die Auswertung mit
   der Hauptkamera eines Telefons (26 mm) und schätzt nach.

   Reine Logik auf einem ArrayBuffer (die ersten 128 KB der Datei
   genügen); liefert null, wenn nichts Brauchbares darin steht.
   ═══════════════════════════════════════════════════════════════ */

function exifBrennweite(puffer) {
  try {
    const d = new DataView(puffer);
    if (d.byteLength < 4 || d.getUint16(0) !== 0xffd8) return null;
    let o = 2;
    while (o + 4 <= d.byteLength) {
      const marke = d.getUint16(o);
      if ((marke & 0xff00) !== 0xff00) return null;
      const laenge = d.getUint16(o + 2);
      if (marke === 0xffe1 && o + 10 <= d.byteLength && d.getUint32(o + 4) === 0x45786966) {
        return tiffLesen(d, o + 10, Math.min(d.byteLength, o + 2 + laenge));
      }
      if (marke === 0xffda) return null;          /* Bilddaten beginnen: keine EXIF davor */
      o += 2 + laenge;
    }
  } catch (e) { /* kaputte Datei: ohne Brennweite weiter */ }
  return null;
}

function tiffLesen(d, start, ende) {
  const klein = d.getUint16(start) === 0x4949;
  const u16 = (p) => d.getUint16(start + p, klein);
  const u32 = (p) => d.getUint32(start + p, klein);
  if (u16(2) !== 42) return null;
  const eintraege = (ifd) => {
    if (start + ifd + 2 > ende) return [];
    const n = u16(ifd), aus = [];
    for (let i = 0; i < n; i++) {
      const p = ifd + 2 + i * 12;
      if (start + p + 12 > ende) break;
      aus.push({ tag: u16(p), typ: u16(p + 2), anzahl: u32(p + 4), wert: p + 8 });
    }
    return aus;
  };
  const ifd0 = eintraege(u32(4));
  const zeiger = ifd0.find((e) => e.tag === 0x8769);
  if (!zeiger) return null;
  let f35 = null, fmm = null;
  for (const e of eintraege(u32(zeiger.wert))) {
    if (e.tag === 0xa405 && e.typ === 3) f35 = u16(e.wert);
    if (e.tag === 0x920a && e.typ === 5) {
      const p = u32(e.wert);
      if (start + p + 8 <= ende) { const z = u32(p), n = u32(p + 4); if (n) fmm = z / n; }
    }
  }
  if (!(f35 > 0) && !(fmm > 0)) return null;
  return { kleinbild: f35 > 0 ? f35 : null, mm: fmm > 0 ? fmm : null };
}

/** Brennweite in Pixeln für ein Bild der Größe b × h (nach dem
    Verkleinern), aus der Kleinbild-Angabe; ohne Angabe 26 mm. */
const brennweitePixel = (exif, b, h) => ((exif && exif.kleinbild) || 26) / 43.27 * Math.hypot(b, h);

export { brennweitePixel, exifBrennweite };
